import { createContext as t, useContext as e, useState as n, useEffect as r, createElement as i, isValidElement as a } from "react";
import { renderToStaticMarkup as u } from "react-dom/server";
function o(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
    var i = 0;
    for (r = Object.getOwnPropertySymbols(t); i < r.length; i++) e.indexOf(r[i]) < 0 && (n[r[i]] = t[r[i]]);
  }
  return n;
}
var s,
  l = function () {
    function t(t) {
      this.input = t, this.index = 0, this.done = !1, this.value = "", this.value = this.input.charAt(this.index);
    }
    return t.prototype.next = function () {
      return this.index++, this.index >= this.input.length && (this.done = !0), this.value = this.input.charAt(this.index);
    }, t.prototype.croak = function () {
      throw Error("[" + this.input + ']. Unexpected character "' + this.value + '" on position ' + this.index + ".");
    }, t;
  }();
!function (t) {
  t[t.Plural = 0] = "Plural", t[t.Select = 1] = "Select", t[t.Text = 2] = "Text", t[t.Variable = 3] = "Variable";
}(s || (s = {}));
var p = ["{", "}", ","],
  h = function () {
    function t(t) {
      this.input = new l(t);
    }
    return t.prototype.next = function () {
      return "{" === this.input.value ? this.readVariable() : this.readText();
    }, t.prototype.skip = function (t) {
      t !== this.input.value && this.input.croak(), this.input.next();
    }, t.prototype.readWhile = function (t) {
      for (var e = ""; !this.input.done && t(this.input.value);) e += this.input.value, this.input.next();
      return e;
    }, t.prototype.readVariable = function () {
      this.skip("{");
      var t = this.readWhile(function (t) {
        return !function (t) {
          return p.includes(t);
        }(t);
      }).trim();
      if (0 === t.length && this.input.croak(), "}" === this.input.value) return this.skip("}"), {
        type: s.Variable,
        value: t
      };
      this.skip(",");
      var e = this.readVariableType();
      return {
        options: this.readVariableOptions(),
        type: e,
        value: t
      };
    }, t.prototype.readText = function () {
      return {
        type: s.Text,
        value: this.readWhile(function (t) {
          return "{" !== t && "}" !== t;
        })
      };
    }, t.prototype.readVariableType = function () {
      var t = this.readWhile(function (t) {
        return "," !== t;
      }).trim();
      return "plural" === t ? s.Plural : "select" === t ? s.Select : void this.input.croak();
    }, t.prototype.readVariableOptions = function () {
      this.skip(",");
      for (var t = {}; "}" !== this.input.value;) t[this.readText().value.trim()] = this.readExpression();
      return this.skip("}"), t;
    }, t.prototype.readExpression = function () {
      var t = [];
      for (this.skip("{"); "}" !== this.input.value;) t.push(this.next());
      return this.skip("}"), t;
    }, t;
  }(),
  c = function () {
    function t(t, e) {
      void 0 === t && (t = "en"), void 0 === e && (e = []);
      var n = e.find(function (e) {
        return e.language === t;
      });
      this.language = t, this.messages = n ? n.messages : {};
    }
    return t.prototype.formatDate = function (t, e) {
      return new Intl.DateTimeFormat(this.language, e).format(t);
    }, t.prototype.formatNumber = function (t, e) {
      return new Intl.NumberFormat(this.language, e).format(t);
    }, t.prototype.translate = function (t, e) {
      void 0 === e && (e = {});
      var n = e.defaultMessage,
        r = o(e, ["defaultMessage"]),
        i = this.messages[t];
      if ("number" == typeof i) return "" + i;
      if (void 0 === i) {
        if ("string" != typeof n) return t;
        i = n;
      }
      try {
        return function (t, e, n) {
          for (var r = new h(e), i = "", a = function a(e) {
              var r = e.options,
                i = e.type,
                u = e.value;
              return i === s.Variable ? n[u] : r ? i === s.Select ? r[n[u]].map(a).join("") : r[new Intl.PluralRules(t).select(n[u])].map(a).join("") : u;
            }; !r.input.done;) i += a(r.next());
          return i;
        }(this.language, i, r);
      } catch (t) {
        console.error("[eo-locale] ", t);
      }
      return i;
    }, t;
  }(),
  f = t({
    language: "",
    locales: [],
    setLanguage: function setLanguage() {},
    translator: new c()
  }, function (t, e) {
    return t.language !== e.language ? 1 : 0;
  });
function v(t) {
  var n = e(f);
  return t && t !== n.language ? new c(t) : n.translator;
}
var d = {
  Context: f,
  Date: function Date(t) {
    var e = t.language,
      n = t.value,
      r = o(t, ["children", "language", "value"]);
    return v(e).formatDate(n, r);
  },
  Number: function Number(t) {
    var e = t.language,
      n = t.value,
      r = o(t, ["children", "language", "value"]);
    return v(e).formatNumber(n, r);
  },
  Provider: function Provider(t) {
    var e = t.children,
      a = t.language,
      u = t.locales,
      o = n(a);
    return r(function () {
      o[1](a);
    }, [a]), i(f.Provider, {
      value: {
        language: o[0],
        locales: u,
        setLanguage: o[1],
        translator: new c(o[0], u)
      }
    }, e);
  },
  Text: function Text(t) {
    var n = t.html,
      r = t.id,
      s = o(t, ["children", "html", "id"]),
      l = e(f);
    Object.keys(s).forEach(function (t) {
      var e = s[t];
      a(e) && (s[t] = u(i(f.Provider, {
        value: l
      }, e)));
    });
    var p = l.translator.translate(r, s);
    return n ? i("span", {
      dangerouslySetInnerHTML: {
        __html: p
      }
    }) : p;
  }
};
export { d as EOLocale, c as Translator, v as useTranslator };